import React, { useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

import adstech from '../assets/icons/Group 22220.svg';
import location from '../assets/icons/Group 22218.svg';
import support from '../assets/icons/Group 22219.svg';

import { lambda } from '../Functions';

export default function Contact() {
  // State for form fields
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false); // State for loader

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true); // Show loader

    // Basic validation
    if (!firstName || !lastName || !email || !comment) {
      setError('All fields are required.');
      setLoading(false);
      return;
    }

    // API request payload
    const formData = { firstName, lastName, email, comment };

    try {
      const response = await fetch(`${lambda}?action=sendcontactus`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSuccess('Your message has been sent successfully.');
        setFirstName('');
        setLastName('');
        setEmail('');
        setComment('');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch (error) {
      setError('Failed to connect to the server.');
    } finally {
      setLoading(false); // Hide loader
    }
  };

  return (
    <div>
      <Navbar />
      <section style={{ marginTop: '100px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-5">
              <h2 className="primary_purple">Get in Touch</h2>
              <h2>with Us now!</h2>
              <p className="text-dark mt-2">
                Have questions or need assistance? We're here <br />
                to help! Reach out to us for support. Your perfect <br />
                gift is just a message away!
              </p>

              <div className="mt-4 d-flex flex-column gap-4">
                <p className="text-dark d-flex flex-row gap-4 align-items-center">
                  <img src={adstech} alt="Ads Tech" />
                  Smart Mobile Tech
                </p>
                <p className="text-dark d-flex flex-row gap-4 align-items-center">
                  <img src={location} alt="Location" />
                  DSO-THUB-G-D-FLEX-G043, Dubai Silicon, Dubai AE
                </p>
                <p className="text-dark d-flex flex-row gap-4 align-items-center">
                  <img src={support} alt="Support" />
                  support@giftbox.mobi
                </p>
              </div>
            </div>

            <div className="col-lg-6 br_15">
              <div className="p-4 rounded shadow-lg" style={{ background: '#EFEBFF' }}>
                <form className="d-flex flex-column gap-3" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="d-flex flex-column">
                        <label className="text-dark fw-bold mb-1">First Name</label>
                        <input
                          className="form-control"
                          placeholder="Enter your first name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="d-flex flex-column">
                        <label className="text-dark fw-bold mb-1">Last Name</label>
                        <input
                          className="form-control"
                          placeholder="Enter your last name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-column">
                    <label className="text-dark fw-bold mb-1">Email</label>
                    <input
                      className="form-control"
                      placeholder="Enter your email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="d-flex flex-column">
                    <label className="text-dark fw-bold mb-1">Comment</label>
                    <textarea
                      className="form-control"
                      placeholder="Write your comment"
                      rows="3"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      required
                    ></textarea>
                  </div>

                  {/* Error / Success Messages */}
                  {error && <p className="text-danger">{error}</p>}
                  {success && <p className="text-success">{success}</p>}

                  <button className="home_button_purple" type="submit" disabled={loading}>
                    {loading ? (
                      <span>
                        <span className="spinner-border spinner-border-sm me-2"></span> Submitting...
                      </span>
                    ) : (
                      'Submit'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
